import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "V",
  "description": "",
  "published": "2006-05-03T00:00:00.000Z",
  "redirect_from": ["/blog/v/swizec/421"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Remember, Remember`}<br parentName="p"></br>{`
`}{`The fifth of November,`}<br parentName="p"></br>{`
`}{`The gunpowder treason and plot.`}<br parentName="p"></br>{`
`}{`I know of no reason`}<br parentName="p"></br>{`
`}{`Why the gunpowder treason`}<br parentName="p"></br>{`
`}{`Should ever be forgot.`}</p>
    <p>{`Danes sem si ogledal sem si film `}<a parentName="p" {...{
        "href": "http://vforvendetta.warnerbros.com/"
      }}>{`V for Vendetta`}</a>{`, narejen po `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/V_for_vendetta"
      }}>{`stripu istega imena`}</a>{`, in moram reči, da je odličen. Dobra zgodba (čeprav nekako spominja na `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Nineteen_Eighty-Four_(novel)"
      }}>{`1984`}</a>{` pomešan z `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Phantom_of_the_opera"
      }}>{`Fantom iz opere`}</a>{`). Igranje je bilo tudi zelo dobro ter prav tako režija. Da ne govorim o posebnih učinkih; najboljši del filma je, ko ura na Big Benu odleti proti gledalcu, skoraj nedotaknjena, medtem, ko se cel stolp dobesedno zdrobi na koščke. Čudovito.`}<br parentName="p"></br>{`
`}<a parentName="p" {...{
        "href": "http://www.imdb.com/name/nm0000204/"
      }}>{`Natalie Portman`}</a>{` je bila odlična kot Evey Hammond, ampak saj je bila odlična tudi v Piratih s Karibov, odlična igralka.`}</p>
    <p><img parentName="p" {...{
        "src": "/includes/editor_upload/Image/306664-200x500.jpg",
        "alt": null
      }}></img></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      